// Kilja: infinite scroll for collection grids. Loads the next ?page=N when the pagination nears the viewport and
// appends its products; the real pagination links stay in the server HTML (crawlable) but are hidden once JS runs.
if (!customElements.get('kilja-infinite')) {
  customElements.define('kilja-infinite', class extends HTMLElement {
    connectedCallback() {
      this.classList.add('is-js');
      this.next = this.dataset.next;
      if (!this.next) return;
      this.io = new IntersectionObserver((e) => { if (e[0].isIntersecting) this.load(); }, { rootMargin: '600px 0px' });
      this.io.observe(this);
    }
    disconnectedCallback() { if (this.io) this.io.disconnect(); }
    async load() {
      if (this.busy || !this.next) return;
      this.busy = true;
      const status = this.querySelector('.kilja-infinite__status');
      status.textContent = 'Hleð fleiri vörum…';
      try {
        const html = await (await fetch(this.next)).text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const grid = document.getElementById('product-grid');
        doc.querySelectorAll('#product-grid > li').forEach((li) => grid.appendChild(document.importNode(li, true)));
        const nextEl = doc.querySelector('kilja-infinite');
        this.next = nextEl ? nextEl.dataset.next : '';
        status.textContent = '';
        if (!this.next) { this.io.disconnect(); this.remove(); }
      } catch (e) {
        status.textContent = '';
        this.classList.remove('is-js'); // fall back to the visible pagination
        this.io.disconnect();
      }
      this.busy = false;
    }
  });
}
